
<template>
  <div class="container" id="clients">
    <div class="row text-center">
      <h2 class="heading-light" v-html="clients.title"></h2>
      <div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">

          <div class="row">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-4 client-object" v-for="(client, index) in displayclients" :key="index">
            <object class="cls-1" :data="'static/img/content/logos/'+client.logo" type="image/svg+xml"></object>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

#clients object {
  max-width: 60px;
  height: 70px;
  margin: 5px 0;
}

@media (min-width: 768px) {
  #clients object {
    max-width: 65px;
    height: 60px;
    margin: 10px 0;
  }
}

</style>

<script>
import {clients} from '../../content.json'

export default {
  data: function () {
    return {
      clients,
      displayclients: []
    }
  },
  methods: {
    getClients: function () {
      this.displayclients = this.getRandomClients(this.clients.array, 18)
    },
    getRandomClients: function (arr, n) {
      var result = new Array(n)
      var len = arr.length
      var taken = new Array(len)

      if (n > len) throw new RangeError('getRandom: more elements taken than available')
      while (n--) {
        var x = Math.floor(Math.random() * len)
        if (n === 11) {
          x = 0
        }
        result[n] = arr[x in taken ? taken[x] : x]
        taken[x] = --len in taken ? taken[len] : len
      }
      return result
    }
  },
  created () {

  },
  destroyed () {

  },
  mounted: function () {
    this.getClients()
  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// ClientSection.vue?76967200